import type { FaireProductEntity } from "../../entity_types/product";

export const p_krp3k6v7zc: FaireProductEntity = {
  token: "p_krp3k6v7zc",
  type: "product",
  name: "Baby Pacifier 5 Pack, 100% Food Garde Silicone by Comfy Cubs",
  brandToken: "b_zcq9sturtm",
  brandName: "Comfy Cubs",
  imageUrl:
    "https://cdn.faire.com/fastly/b736636bb3b7189e13845d221406cb64a81f5de1acfbfffae4dcfdb1fa267c8c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4370d5d97d46f92293f94ed85ef68e135ae8986bf835eff17dbe7e01732842c.png",
    "https://cdn.faire.com/fastly/b82419fa6377c7b0830b823f2f0f4fcb53cae30060358ff52f8944aef5de5878.png",
    "https://cdn.faire.com/fastly/d9180748f181185678aecd1434c511fac58af67183be7a93c21857cb73ba470f.png",
    "https://cdn.faire.com/fastly/29babc1ef916e007d11abd512433ee5972ccd8101d04f610f30e649b270c8861.png",
    "https://cdn.faire.com/fastly/050f50e2440965fe1103185ed15fc0eb1ff08b26f1f76cc552e2b605b4d0576d.png",
    "https://cdn.faire.com/fastly/0510c944e85d4dd22272f64277b3216964f423cb1317d3d9571dce8a2bfbef80.png",
    "https://cdn.faire.com/fastly/e9014307e9ca28e2d62071171877ef1622747c7d3973b30dce748bba6e59adb9.png",
    "https://cdn.faire.com/fastly/688af2a4f5c7a845710ee63271911b664754a2e3f5c11cfa9369c4bad004960e.png",
    "https://cdn.faire.com/fastly/e2fbd031e3514507ad2e37da4b0d314135c96f00c280c822684bb83514acc4c4.png",
    "https://cdn.faire.com/fastly/c3be1d15f251075bbbe1b3b9b9d287814b02a2df5a4250d1654ccdcbab0c7444.png",
    "https://cdn.faire.com/fastly/002cea166f25e35ed68b467db516385703a4cbdc1cbc45c178427ea813ac0e6f.png",
    "https://cdn.faire.com/fastly/dd13961defa3ddb6590f8835c44b1b9e667c6206be53970749fdb7da7411a730.png",
    "https://cdn.faire.com/fastly/a2a69c82c25651a14466ed069cac73425efe848e79140dd4d62329202eb3f872.png",
    "https://cdn.faire.com/fastly/c21bf4d401543e7e34393ce510fad17cbf9c2a2dc5cf6e10a116d05b9ea239f5.png",
    "https://cdn.faire.com/fastly/c4dbd1e49e7347035898569912a2ee352c433c9ee8f1f19583dfbea05f726c4e.png",
    "https://cdn.faire.com/fastly/c65905badaf9fff8d7cfe19da8be03f652d9301647de5e587bdba3cc1997c651.png",
    "https://cdn.faire.com/fastly/fb35f095c96249ab7d9d338f2eba492cdbafe32093cb4b830d0f588e6bec671a.png",
  ],
  priceDollars: 7,
  description:
    "Comfy Cubs Pacifiers and baby products are designed for your baby's comfort and safety. Made from durable, 100% food-grade silicone, these baby pacifiers are free of BPA, PVC, phthalate, and latex, ensuring non-toxic and safe use for your little one.\n\nThe pacifier's breast-like nipple shape naturally fits your baby's palate, making it ideal for breastfed infants. With two safety air holes, these pacifiers are suitable for babies from birth and up, ensuring added security as your baby grows.\n\nOur pacifier newborn meet stringent CPSIA safety standards, giving parents peace of mind. Each pack includes five pacifiers in beautiful colors, making it easy to match with any outfit. Soft and soothing, these bulk pacifiers are designed to provide comfort and calm for your baby, making them a reliable choice for everyday use.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:10.226Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
